<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4"><a><button class=" m-auto btn btn-primary btn-back top-back-button" (click)="back()"><i
                                class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Change Password</div>
                    <p id="addthereco" >
                        <span class="runningText" [innerHTML]="userStoreService?.outComeText">
                        <!-- Your logged in with a temporary password.<br/>
                        Please change to a permanent one. -->
                    </span></p>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>
                <div class="col-12 alert alert-danger" role="alert" *ngIf="errorMessage" > &nbsp;<span [innerHTML]="errorMessage"></span></div>
                <form autocomplete="off" class="text-left mt-4 mb-b w100" [formGroup]="changePassswordForm">
                    <div class="row">
                    <div class="col-12 col-sm-6 m-auto">
                        <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div>
                     
                    <div class="row no-margin">
                        <!-- <div class="col-12 alert-danger" role="alert"> Please correct fields in error. </div>
                        <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div> -->
                        <div class="col-12 col-sm-12 mb-4">
                            <label  class="lblPin">Current Password*</label><input type="password"
                                class="form-control" formControlName="currentPassword" [ngClass]="{ 'is-invalid': submitted && f.currentPassword.errors }">
                                <div *ngIf="submitted && f.currentPassword.errors && f.currentPassword.errors"  class="invalid-feedback">Password is required.</div>
                        </div>
                      
                        <div class="col-12 col-sm-12 mb-4">
                            <label  class="lblPin">New Password*</label><input type="password" class="form-control" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                            <div *ngIf="submitted && f.password.errors &&  f.password.errors.required"  class="invalid-feedback">Password is required.</div>

                            <div class="mt-4">
                               <div [ngClass]="(f.password?.errors?.invalidLength)?'fail':'sucess' ||  f.password.errors.pattern" > Use 8 or more characters</div>
                                <div [ngClass]="(f.password?.errors?.invalidLetters)?'fail':'sucess'" >Use upper and lower case letters</div>
                                <div [ngClass]="(f.password?.errors?.invalidNumbers)?'fail':'sucess'" >Use numbers</div>
                                <div [ngClass]="(f.password?.errors?.invalidSymbols)?'fail':'sucess'" >Use symbols</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 mb-4">
                            <label  class="lblPin">Confirm New Password*</label><input type="password" class="form-control"  formControlName="confirmPassword" [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }">
                            <div *ngIf="submitted && f.confirmPassword.errors && f.confirmPassword.errors.required"  class="invalid-feedback">Confirm Password is required.</div>
                            <div *ngIf="submitted && f.confirmPassword.errors && f.confirmPassword?.errors?.mustMatch" class="invalid-feedback">Passwords must match</div>
                        </div>
                       
                     
                        
                    </div>
                </div>
            </div>

                   
                </form>
            </div>

            <div class="container m-auto text-center"><a><button class="btn btn-primary btn-back"  (click)="back()">Cancel</button></a><a><button
                        class="btn btn-primary  btn-continue m-auto" (click)="save()">Save</button></a></div>
        </div>
    </div>
</div>